import React from "react";
import Nav from "../../components/nav";
import Footer from "../../components/footer";
import Fairsph from "../../assets/pic/fairs.jpg"
import {Helmet} from "react-helmet";

const Fairs = ()=>{
    return(
        <div className='fairs-wrap'>
            <Helmet>
                <title>نمایشگاه آنلاین و مجازی</title>
                <meta name="description" content="فروشگاه اینترنتی از حیث میزان فروش، برقراری ارتباط با مشتریان، تبلیغات دهان به دهان و بسیاری پارامترهای دیگر برتری قابل ملاحظه‌ای نسبت به یک فروشگاه فیزیکی دارد." />
            </Helmet>
            <Nav/>
            <div className='webinar-dec'>
                <h1>نمایشگاه مجازی</h1>
                <img src={Fairsph} alt="نمایشگاه مجازی"/>
                <p>
                    بدیهی است که اگر یک فروشگاه فیزیکی که محدود به یک موقعیت جغرافیایی خاص است را با یک فروشگاه اینترنتی که در سطح یک کشور یا حتی فراتر از مرزها فعالیت می‌کند، مقایسه کنید، فروشگاه اینترنتی از حیث میزان فروش، برقراری ارتباط با مشتریان، تبلیغات دهان به دهان و بسیاری پارامترهای دیگر برتری قابل ملاحظه‌ای نسبت به یک فروشگاه فیزیکی دارد.
                </p>
                <p>
                    به طور مشابه همین امر در خصوص نمایشگاه فیزیکی و نمایشگاه مجازی (آنلاین) نیز صادق است. به عنوان مثال، نمایشگاه کتاب که هر ساله به طور فیزیکی و در مکانی خاص برگزار می‌شد، در شرایط همه‌گیری ویروس کرونا به صورت مجازی برگزار شد و طبق بررسی آمارها، میزان تعامل مردم با نمایشگاه کتاب افزایش پیدا کرد.
                </p>
                <p>
                    می‌توان گفت که مهم‌ترین عامل در این خصوص، محدود نبودن نمایشگاه مجازی (آنلاین) به زمان و مکان است. در این صورت همه افراد می‌توانند از هر کشور و شهر و در هر ساعت از شبانه‌روز در نمایشگاه مجازی شرکت کنند.
                </p>
                <p>
                    نمایشگاه مجازی بر بستر وب (اینترنت) برگزار شده و با حذف مکان برگزاری و رفت و آمد‌های مکرر به آن، منجر به صرفه‌جویی قابل ملاحظه‌ای در هزینه‌های برگزارکننده و شرکت‌کننده می‌شود.
                </p>
                <p>
                    جهت برگزاری یک نمایشگاه مجازی یا همان نمایشگاه آنلاین‌ روش‌های مختلفی وجود دارد، اما روش مؤثرتر آن است که حداکثر تعامل با بازدیدکنندگان ایجاد شود. به همین منظور استفاده از پلتفرم‌هایی پیشنهاد می‌شود که امکان تعامل صوتی و تصویری با کیفیت بالا، گفتگو و تعامل متنی (چت)، پخش ویدئو، اشتراک گذاری فایل (به ویژه کاتالوگ‌ها) و امکان ایجاد اعلانات مختلف در آن وجود داشته باشد.
                </p>
                <p>
                    پلتفرم جامع برگزاری جلسات مجازی BellMeet‌، تنها پلتفرم بومی و دانش دانش بنیان با کامل‌ترین ابزارهای تعاملی که در فوق نیز ذکر شد، آماده میزبانی بستر نمایشگاه مجازی شما است.
                </p>
            </div>
            <Footer/>
        </div>
    )
}

export default Fairs